/**
 * Shared client-side handling for the AI credit enforcement gate (issue #74).
 *
 * When enforcement is on and the user's credit pool is exhausted, a gated
 * web-role endpoint refuses BEFORE contacting the AI with:
 *
 *   HTTP 402  { "code": "credits_exhausted", "message": "..." }
 *
 * The UIs surface one consistent, friendly message pointing at the account
 * page's Buy Credits panel instead of a generic "server error".
 */

export const CREDITS_EXHAUSTED_CODE = "credits_exhausted";

export const CREDITS_EXHAUSTED_MESSAGE =
    "You've used all your AI credits. Top up from your account page, or wait for your next billing period.";

/**
 * True when an HTTP failure is the credit gate's rejection. Either signal
 * settles it: nothing else in the product answers 402, and not every caller
 * has parsed the body code.
 */
export function isCreditsExhausted(status: number, code?: string | null): boolean {
    return status === 402 || code === CREDITS_EXHAUSTED_CODE;
}
